module.exports = __webpack_public_path__ + "img/playerList.78f401b4.svg";